export default __webpack_public_path__ + "static/media/23-ThordalVentilation.3d8bbe39.png";